var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cwp-map"},[_c('cwp-loader',{staticClass:"cwp-loader--absolute",attrs:{"loading":_vm.loading}}),_c('div',{staticClass:"cwp-map__frame",attrs:{"height":"300","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }